import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import SEO from './SEO';

interface RoleRouteProps {
  children: React.ReactNode;
  /** If empty array, any authenticated user is allowed */
  allowedTypes?: string[];
}

/**
 * Unified route guard replacing PrivateRoute, AdminRoute,
 * TutorMentorRoute, ManagerRoute, ParentRoute, StudentRoute.
 */
const RoleRoute: React.FC<RoleRouteProps> = ({ children, allowedTypes = [] }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div data-testid="route-loading">Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (allowedTypes.length > 0 && !allowedTypes.includes(user.user_type)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <><SEO noIndex />{children}</>;
};

export default RoleRoute;
